import { render, staticRenderFns } from "./PublicUser.vue?vue&type=template&id=15728cea&scoped=true"
import script from "./PublicUser.vue?vue&type=script&lang=js"
export * from "./PublicUser.vue?vue&type=script&lang=js"
import style0 from "./PublicUser.vue?vue&type=style&index=0&id=15728cea&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15728cea",
  null
  
)

export default component.exports